var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnAnimal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 62,
    viewBox: "0 0 89 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4748 17.788L27.199 23.0372L28.4317 24.162L31.1816 17.6943L29.4748 17.788Z",
    fill: "#940006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1473 17.788L19.4231 23.0372L18.1903 24.162L15.4404 17.6943L17.1473 17.788Z",
    fill: "#940006"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00098 27.0676L11.8371 31.0982L12.5009 28.9423L7.66473 25.1929L7.00098 27.0676Z",
    fill: "#940006"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.673 27.0676L33.8369 31.0982L33.1731 28.9423L38.0092 25.1929L38.673 27.0676Z",
    fill: "#940006"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8041 29.2841C7.45734 29.2841 9.60821 27.2117 9.60821 24.6552C9.60821 22.0988 7.45734 20.0264 4.8041 20.0264C2.15087 20.0264 0 22.0988 0 24.6552C0 27.2117 2.15087 29.2841 4.8041 29.2841Z",
    fill: "#FFBF00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8041 28.8117C7.45734 28.8117 9.60821 26.8451 9.60821 24.4191C9.60821 21.993 7.45734 20.0264 4.8041 20.0264C2.15087 20.0264 0 21.993 0 24.4191C0 26.8451 2.15087 28.8117 4.8041 28.8117Z",
    fill: "#940006"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56391 27.7829C7.08448 27.7829 9.12781 26.0465 9.12781 23.9046C9.12781 21.7627 7.08448 20.0264 4.56391 20.0264C2.04333 20.0264 0 21.7627 0 23.9046C0 26.0465 2.04333 27.7829 4.56391 27.7829Z",
    fill: "url(#paint0_radial_2_13135)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4.56401 27.7827C7.08461 27.7827 9.12798 26.0463 9.12798 23.9044C9.12748 23.4317 9.02702 22.9643 8.83305 22.5322C8.68079 22.8287 8.48605 23.1018 8.25485 23.3433C7.57575 24.0506 6.65085 24.4818 5.70837 24.7701C4.48974 25.1429 3.17642 25.3006 1.93447 25.0126C1.22851 24.8511 0.568888 24.5331 0.00537109 24.0828C0.115197 26.1418 2.11391 27.7827 4.56401 27.7827Z",
    fill: "#DBA75C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69171 26.224C5.62035 26.224 6.37317 25.5153 6.37317 24.6411C6.37317 23.7668 5.62035 23.0581 4.69171 23.0581C3.76307 23.0581 3.01025 23.7668 3.01025 24.6411C3.01025 25.5153 3.76307 26.224 4.69171 26.224Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53153 25.8282C5.37171 25.8282 6.05281 25.2081 6.05281 24.4432C6.05281 23.6782 5.37171 23.0581 4.53153 23.0581C3.69135 23.0581 3.01025 23.6782 3.01025 24.4432C3.01025 25.2081 3.69135 25.8282 4.53153 25.8282Z",
    fill: "#574120"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.73091 24.0076C4.08469 24.0076 4.37148 23.7241 4.37148 23.3744C4.37148 23.0247 4.08469 22.7412 3.73091 22.7412C3.37713 22.7412 3.09033 23.0247 3.09033 23.3744C3.09033 23.7241 3.37713 24.0076 3.73091 24.0076Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2093 23.5698C6.91683 23.5698 7.49038 23.0028 7.49038 22.3035C7.49038 21.6041 6.91683 21.0371 6.2093 21.0371C5.50178 21.0371 4.92822 21.6041 4.92822 22.3035C4.92822 23.0028 5.50178 23.5698 6.2093 23.5698Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0793 29.2841C42.7325 29.2841 44.8834 27.2117 44.8834 24.6552C44.8834 22.0988 42.7325 20.0264 40.0793 20.0264C37.426 20.0264 35.2751 22.0988 35.2751 24.6552C35.2751 27.2117 37.426 29.2841 40.0793 29.2841Z",
    fill: "#FFBF00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0793 28.8117C42.7325 28.8117 44.8834 26.8451 44.8834 24.4191C44.8834 21.993 42.7325 20.0264 40.0793 20.0264C37.426 20.0264 35.2751 21.993 35.2751 24.4191C35.2751 26.8451 37.426 28.8117 40.0793 28.8117Z",
    fill: "#940006"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8391 27.7829C42.3596 27.7829 44.403 26.0465 44.403 23.9046C44.403 21.7627 42.3596 20.0264 39.8391 20.0264C37.3185 20.0264 35.2751 21.7627 35.2751 23.9046C35.2751 26.0465 37.3185 27.7829 39.8391 27.7829Z",
    fill: "url(#paint1_radial_2_13135)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M39.8388 27.7827C42.3594 27.7827 44.4028 26.0463 44.4028 23.9044C44.4023 23.4317 44.3018 22.9643 44.1079 22.5322C43.9556 22.8287 43.7609 23.1018 43.5297 23.3433C42.8506 24.0506 41.9257 24.4818 40.9833 24.7701C39.7646 25.1429 38.4512 25.3006 37.2093 25.0126C36.5034 24.8511 35.8438 24.5332 35.2803 24.0828C35.39 26.1418 37.3887 27.7827 39.8388 27.7827Z",
    fill: "#DBA75C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9669 26.224C40.8955 26.224 41.6483 25.5153 41.6483 24.6411C41.6483 23.7668 40.8955 23.0581 39.9669 23.0581C39.0382 23.0581 38.2854 23.7668 38.2854 24.6411C38.2854 25.5153 39.0382 26.224 39.9669 26.224Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8067 25.8282C40.6469 25.8282 41.328 25.2081 41.328 24.4432C41.328 23.6782 40.6469 23.0581 39.8067 23.0581C38.9665 23.0581 38.2854 23.6782 38.2854 24.4432C38.2854 25.2081 38.9665 25.8282 39.8067 25.8282Z",
    fill: "#574120"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0061 24.0076C39.3598 24.0076 39.6466 23.7241 39.6466 23.3744C39.6466 23.0247 39.3598 22.7412 39.0061 22.7412C38.6523 22.7412 38.3655 23.0247 38.3655 23.3744C38.3655 23.7241 38.6523 24.0076 39.0061 24.0076Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4845 23.5698C42.192 23.5698 42.7655 23.0028 42.7655 22.3035C42.7655 21.6041 42.192 21.0371 41.4845 21.0371C40.7769 21.0371 40.2034 21.6041 40.2034 22.3035C40.2034 23.0028 40.7769 23.5698 41.4845 23.5698Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7606 20.2855C17.4139 20.2855 19.5648 18.2131 19.5648 15.6567C19.5648 13.1002 17.4139 11.0278 14.7606 11.0278C12.1074 11.0278 9.95654 13.1002 9.95654 15.6567C9.95654 18.2131 12.1074 20.2855 14.7606 20.2855Z",
    fill: "#FFBF00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7606 19.8132C17.4139 19.8132 19.5648 17.8465 19.5648 15.4205C19.5648 12.9945 17.4139 11.0278 14.7606 11.0278C12.1074 11.0278 9.95654 12.9945 9.95654 15.4205C9.95654 17.8465 12.1074 19.8132 14.7606 19.8132Z",
    fill: "#940006"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5204 18.7849C17.041 18.7849 19.0844 17.0485 19.0844 14.9066C19.0844 12.7647 17.041 11.0283 14.5204 11.0283C11.9999 11.0283 9.95654 12.7647 9.95654 14.9066C9.95654 17.0485 11.9999 18.7849 14.5204 18.7849Z",
    fill: "url(#paint2_radial_2_13135)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.5203 18.7841C17.0412 18.7841 19.0842 17.0478 19.0842 14.9059C19.0837 14.4332 18.9833 13.9658 18.7893 13.5337C18.6371 13.8301 18.4423 14.1033 18.2111 14.3447C17.532 15.0522 16.6071 15.4833 15.6647 15.7716C14.446 16.1444 13.1326 16.3021 11.8907 16.0141C11.1848 15.8525 10.5252 15.5346 9.96167 15.0843C10.0715 17.1433 12.0701 18.7841 14.5203 18.7841Z",
    fill: "#DBA75C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6483 17.2255C15.5769 17.2255 16.3297 16.5168 16.3297 15.6425C16.3297 14.7683 15.5769 14.0596 14.6483 14.0596C13.7196 14.0596 12.9668 14.7683 12.9668 15.6425C12.9668 16.5168 13.7196 17.2255 14.6483 17.2255Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4881 16.8297C15.3283 16.8297 16.0094 16.2096 16.0094 15.4446C16.0094 14.6797 15.3283 14.0596 14.4881 14.0596C13.6479 14.0596 12.9668 14.6797 12.9668 15.4446C12.9668 16.2096 13.6479 16.8297 14.4881 16.8297Z",
    fill: "#574120"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6874 15.0091C14.0412 15.0091 14.328 14.7256 14.328 14.3759C14.328 14.0262 14.0412 13.7427 13.6874 13.7427C13.3337 13.7427 13.0469 14.0262 13.0469 14.3759C13.0469 14.7256 13.3337 15.0091 13.6874 15.0091Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1658 14.5713C16.8734 14.5713 17.4469 14.0043 17.4469 13.3049C17.4469 12.6055 16.8734 12.0386 16.1658 12.0386C15.4583 12.0386 14.8848 12.6055 14.8848 13.3049C14.8848 14.0043 15.4583 14.5713 16.1658 14.5713Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9762 20.2855C33.6295 20.2855 35.7803 18.2131 35.7803 15.6567C35.7803 13.1002 33.6295 11.0278 30.9762 11.0278C28.323 11.0278 26.1721 13.1002 26.1721 15.6567C26.1721 18.2131 28.323 20.2855 30.9762 20.2855Z",
    fill: "#FFBF00"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9762 19.8132C33.6295 19.8132 35.7803 17.8465 35.7803 15.4205C35.7803 12.9945 33.6295 11.0278 30.9762 11.0278C28.323 11.0278 26.1721 12.9945 26.1721 15.4205C26.1721 17.8465 28.323 19.8132 30.9762 19.8132Z",
    fill: "#940006"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M30.736 18.7849C33.2566 18.7849 35.2999 17.0485 35.2999 14.9066C35.2999 12.7647 33.2566 11.0283 30.736 11.0283C28.2154 11.0283 26.1721 12.7647 26.1721 14.9066C26.1721 17.0485 28.2154 18.7849 30.736 18.7849Z",
    fill: "url(#paint3_radial_2_13135)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.7359 18.7841C33.2564 18.7841 35.2998 17.0478 35.2998 14.9059C35.2993 14.4332 35.1988 13.9658 35.0049 13.5337C34.8526 13.8301 34.6579 14.1033 34.4267 14.3447C33.7476 15.0522 32.8227 15.4833 31.8802 15.7716C30.6616 16.1444 29.3482 16.3021 28.1063 16.0141C27.4003 15.8525 26.7407 15.5346 26.1772 15.0843C26.287 17.1433 28.2857 18.7841 30.7359 18.7841Z",
    fill: "#DBA75C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8638 17.2255C31.7925 17.2255 32.5453 16.5168 32.5453 15.6425C32.5453 14.7683 31.7925 14.0596 30.8638 14.0596C29.9352 14.0596 29.1824 14.7683 29.1824 15.6425C29.1824 16.5168 29.9352 17.2255 30.8638 17.2255Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7037 16.8297C31.5438 16.8297 32.2249 16.2096 32.2249 15.4446C32.2249 14.6797 31.5438 14.0596 30.7037 14.0596C29.8635 14.0596 29.1824 14.6797 29.1824 15.4446C29.1824 16.2096 29.8635 16.8297 30.7037 16.8297Z",
    fill: "#574120"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M29.903 15.0091C30.2568 15.0091 30.5436 14.7256 30.5436 14.3759C30.5436 14.0262 30.2568 13.7427 29.903 13.7427C29.5492 13.7427 29.2625 14.0262 29.2625 14.3759C29.2625 14.7256 29.5492 15.0091 29.903 15.0091Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3814 14.5713C33.0889 14.5713 33.6625 14.0043 33.6625 13.3049C33.6625 12.6055 33.0889 12.0386 32.3814 12.0386C31.6739 12.0386 31.1003 12.6055 31.1003 13.3049C31.1003 14.0043 31.6739 14.5713 32.3814 14.5713Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35906 58.3823C9.35906 58.3823 3.26374 58.5649 5.66492 61.121C8.06609 63.6772 17.4862 59.8429 17.4862 59.8429L9.35906 58.3823Z",
    fill: "url(#paint4_radial_2_13135)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0592 58.3823C37.0592 58.3823 43.1546 58.5649 40.7534 61.121C38.3521 63.6772 28.9321 59.8429 28.9321 59.8429L37.0592 58.3823Z",
    fill: "url(#paint5_radial_2_13135)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7958 42.5186C41.3376 46.6808 43.908 53.3089 40.2714 57.2464C36.4258 61.4105 28.0281 60.9075 23.0033 60.9075C17.9786 60.9075 9.58087 61.4103 5.73526 57.2464C2.09869 53.309 4.66903 46.6809 6.21086 42.5186C8.61798 36.0204 13.8295 21.0338 23.0033 21.0337C32.1772 21.0336 37.3887 36.0206 39.7958 42.5186Z",
    fill: "url(#paint6_radial_2_13135)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6397 32.4522C32.7291 26.6212 28.605 21.0336 23.0035 21.0337C13.8296 21.0337 8.61813 36.0204 6.21101 42.5186C4.8737 46.1289 2.76545 51.593 4.60188 55.5486C4.40263 54.133 4.43377 52.695 4.69413 51.2892C5.59687 46.4928 12.2545 22.5111 21.9588 21.9534C27.1648 21.6542 32.1427 27.1973 35.6397 32.4522Z",
    fill: "#FFBF00"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4302 28.9868C15.4302 28.9868 21.9747 33.6917 29.9075 28.9868C29.9075 28.9868 20.7848 31.3393 15.4302 28.9868Z",
    fill: "#940006"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0861 29.905C17.0861 29.905 16.9679 26.9236 17.5001 26.6898C18.0323 26.456 20.457 27.1575 20.457 27.1575L19.5088 30.6875L17.0861 29.905Z",
    fill: "#FFDEF8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2006 29.8517C28.2006 29.8517 28.32 26.8436 27.7877 26.6097C27.2555 26.3759 24.8308 27.0774 24.8308 27.0774L25.8361 30.7018L28.2006 29.8517Z",
    fill: "#FFDEF8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.8586 59.1385C11.3115 59.2158 11.7664 59.2836 12.2239 59.336C16.4868 59.8247 21.0043 59.1828 25.1998 58.3933C29.0988 57.6596 33.0454 56.6242 36.6406 54.9318C38.563 54.0269 40.5631 52.904 42.1113 51.4332C41.9799 48.3108 40.7085 44.983 39.7957 42.5188C39.6701 42.1799 39.536 41.8154 39.395 41.4336C36.1263 46.686 30.1403 50.4048 24.4344 52.5224C20.2329 54.0816 15.7238 54.9895 11.2235 54.7815C9.07078 54.6714 6.9392 54.3068 4.87428 53.6955C4.58826 53.6122 4.28899 53.5217 3.98364 53.4227C4.12794 54.4122 4.43397 55.3535 4.95505 56.208C4.95519 56.2078 7.20835 57.9726 10.8586 59.1385Z",
    fill: "#940006"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09795 42.9021C6.09795 42.9021 17.1152 50.8962 18.2872 48.2315C19.4593 45.5668 9.3795 38.5243 8.2073 39.3357C7.0351 40.147 5.74637 42.0911 6.09795 42.9021Z",
    fill: "url(#paint7_radial_2_13135)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20707 39.3356C7.04602 40.139 5.77122 42.0541 6.08928 42.8783C6.54787 42.1349 7.16491 41.4994 7.89739 41.0158C8.4641 40.6441 9.13421 40.3621 9.80898 40.4443C10.353 40.5106 10.8378 40.8041 11.2998 41.0955C13.9642 42.7762 16.6634 44.8019 17.7301 47.7429C17.834 48.0232 17.9119 48.3122 17.963 48.6063C18.1077 48.5176 18.2209 48.3866 18.287 48.2314C19.4591 45.5667 9.37914 38.5246 8.20707 39.3356Z",
    fill: "#FFBF00"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7414 42.5945C39.7414 42.5945 28.7242 50.5885 27.5522 47.9238C26.3801 45.2591 36.4599 38.217 37.6321 39.028C38.8043 39.839 40.093 41.7834 39.7414 42.5945Z",
    fill: "url(#paint8_radial_2_13135)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6321 39.028C38.7931 39.8314 40.0679 41.7465 39.7499 42.5707C39.2913 41.8273 38.6743 41.1918 37.9418 40.7083C37.3751 40.3366 36.705 40.0544 36.0302 40.1367C35.4862 40.203 35.0015 40.4966 34.5395 40.788C31.875 42.4686 29.1757 44.4943 28.109 47.4354C28.0052 47.7156 27.9272 48.0047 27.8761 48.2989C27.7314 48.2101 27.6182 48.079 27.5521 47.9239C26.3801 45.2591 36.46 38.217 37.6321 39.028Z",
    fill: "#FFBF00"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7558 58.3823C52.7558 58.3823 46.6605 58.5649 49.0616 61.121C51.4628 63.6772 60.8831 59.8429 60.8831 59.8429L52.7558 58.3823Z",
    fill: "url(#paint9_radial_2_13135)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4559 58.3823C80.4559 58.3823 86.5513 58.5649 84.1501 61.121C81.7488 63.6772 72.3289 59.8429 72.3289 59.8429L80.4559 58.3823Z",
    fill: "url(#paint10_radial_2_13135)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0936 38.3771L52.6137 37.7059C51.5536 37.116 50.4086 36.6893 49.2184 36.4405C48.2798 36.2445 47.2632 36.1693 46.3948 36.5723C45.1482 37.1508 44.5184 38.5874 44.441 39.9467C44.4067 40.5476 44.4627 41.1674 44.7225 41.7116C45.2787 42.8763 46.6054 43.4379 47.8211 43.9011L50.8838 45.0681C51.001 45.1128 51.1301 45.158 51.2493 45.1187C51.3228 45.0894 51.3876 45.0423 51.4379 44.9818C51.8125 44.5817 51.9656 44.0317 52.1064 43.5045L52.762 41.0503L52.6611 39.2843C52.6606 39.3258 53.0936 38.3356 53.0936 38.3771Z",
    fill: "url(#paint11_radial_2_13135)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4031 38.3766L79.8829 37.7054C80.9431 37.1155 82.088 36.6888 83.2783 36.44C84.2169 36.244 85.2335 36.1688 86.1019 36.5718C87.3485 37.1503 87.9782 38.587 88.0557 39.9462C88.09 40.5471 88.034 41.1669 87.7741 41.7112C87.218 42.8758 85.8913 43.4374 84.6755 43.9007L81.6129 45.0677C81.4957 45.1124 81.3666 45.1575 81.2473 45.1182C81.1739 45.0889 81.1091 45.0418 81.0588 44.9813C80.6842 44.5812 80.5311 44.0312 80.3903 43.504L79.7347 41.0498L79.8356 39.2838C79.836 39.3253 79.4031 38.3351 79.4031 38.3766Z",
    fill: "url(#paint12_radial_2_13135)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1928 42.5186C84.7346 46.6808 87.3049 53.3089 83.6684 57.2464C79.8228 61.4105 71.4251 60.9075 66.4003 60.9075C61.3755 60.9075 52.9778 61.4103 49.1322 57.2464C45.4957 53.309 48.066 46.6809 49.6078 42.5186C52.0149 36.0204 57.2265 21.0338 66.4003 21.0337C75.5741 21.0336 80.7856 36.0206 83.1928 42.5186Z",
    fill: "url(#paint13_radial_2_13135)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0364 32.4522C76.1258 26.6212 72.0017 21.0336 66.4002 21.0337C57.2264 21.0337 52.0149 36.0204 49.6077 42.5186C48.2704 46.1289 46.1622 51.593 47.9986 55.5486C47.7994 54.133 47.8305 52.695 48.0909 51.2892C48.9936 46.4928 55.6512 22.5111 65.3555 21.9534C70.5612 21.6542 75.5392 27.1973 79.0364 32.4522Z",
    fill: "#FFADEF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3349 34.3837C69.5138 34.3837 72.0908 31.9007 72.0908 28.8378C72.0908 25.775 69.5138 23.292 66.3349 23.292C63.1561 23.292 60.5791 25.775 60.5791 28.8378C60.5791 31.9007 63.1561 34.3837 66.3349 34.3837Z",
    fill: "#FFC7F4"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3349 33.8178C69.5138 33.8178 72.0908 31.4616 72.0908 28.5549C72.0908 25.6483 69.5138 23.292 66.3349 23.292C63.1561 23.292 60.5791 25.6483 60.5791 28.5549C60.5791 31.4616 63.1561 33.8178 66.3349 33.8178Z",
    fill: "#87006C"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0472 32.5851C69.0671 32.5851 71.5152 30.5048 71.5152 27.9385C71.5152 25.3723 69.0671 23.292 66.0472 23.292C63.0272 23.292 60.5791 25.3723 60.5791 27.9385C60.5791 30.5048 63.0272 32.5851 66.0472 32.5851Z",
    fill: "url(#paint14_radial_2_13135)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M66.0472 32.585C69.0672 32.585 71.5153 30.5047 71.5153 27.9384C71.5147 27.3721 71.3944 26.8121 71.162 26.2944C70.9796 26.6496 70.7463 26.9769 70.4693 27.2662C69.6556 28.1137 68.5475 28.6302 67.4183 28.9757C65.9585 29.4223 64.3847 29.6113 62.8969 29.2662C62.051 29.0727 61.2606 28.6918 60.5854 28.1522C60.7171 30.6192 63.1117 32.585 66.0472 32.585Z",
    fill: "#DBA75C"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2001 30.7174C67.3128 30.7174 68.2147 29.8683 68.2147 28.8209C68.2147 27.7734 67.3128 26.9243 66.2001 26.9243C65.0875 26.9243 64.1855 27.7734 64.1855 28.8209C64.1855 29.8683 65.0875 30.7174 66.2001 30.7174Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0083 30.2433C67.0149 30.2433 67.831 29.5003 67.831 28.5838C67.831 27.6673 67.0149 26.9243 66.0083 26.9243C65.0016 26.9243 64.1855 27.6673 64.1855 28.5838C64.1855 29.5003 65.0016 30.2433 66.0083 30.2433Z",
    fill: "#574120"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5916 27.8396C65.8913 27.5434 65.8913 27.0631 65.5916 26.7668C65.2919 26.4706 64.806 26.4706 64.5063 26.7668C64.2066 27.0631 64.2066 27.5434 64.5063 27.8396C64.806 28.1359 65.2919 28.1359 65.5916 27.8396Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0183 27.5375C68.866 27.5375 69.5533 26.8582 69.5533 26.0202C69.5533 25.1822 68.866 24.5029 68.0183 24.5029C67.1706 24.5029 66.4834 25.1822 66.4834 26.0202C66.4834 26.8582 67.1706 27.5375 68.0183 27.5375Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2634 43.4741C57.2634 43.4741 65.4127 49.3327 75.2906 43.4741C75.2906 43.4741 63.931 46.4034 57.2634 43.4741Z",
    fill: "#87006C"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3252 44.6172C59.3252 44.6172 59.178 40.9048 59.8407 40.6136C60.5034 40.3225 63.5227 41.1959 63.5227 41.1959L62.342 45.5915L59.3252 44.6172Z",
    fill: "#FFDEF8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1652 44.5513C73.1652 44.5513 73.3139 40.8056 72.651 40.5145C71.9882 40.2233 68.969 41.0968 68.969 41.0968L70.2209 45.6099L73.1652 44.5513Z",
    fill: "#FFDEF8"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M54.2556 59.1385C54.7084 59.2158 55.1634 59.2836 55.6208 59.336C59.8838 59.8247 64.4013 59.1828 68.5967 58.3933C72.4958 57.6596 76.4423 56.6242 80.0375 54.9318C81.96 54.0269 83.9601 52.904 85.5082 51.4332C85.3768 48.3108 84.1055 44.983 83.1927 42.5188C83.0671 42.1799 82.933 41.8154 82.792 41.4336C79.5233 46.686 73.5373 50.4048 67.8314 52.5224C63.6298 54.0816 59.1207 54.9895 54.6204 54.7815C52.4677 54.6714 50.3362 54.3068 48.2713 53.6955C47.9852 53.6122 47.686 53.5217 47.3806 53.4227C47.5249 54.4122 47.8309 55.3535 48.352 56.208C48.3521 56.2078 50.605 57.9726 54.2556 59.1385Z",
    fill: "#87006C"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M64.0232 22.0483C64.0232 22.0483 67.3628 31.23 75.1127 25.5193L64.0232 22.0483Z",
    fill: "#87006C"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0232 22.0482L81.201 5.43311L75.2904 26.0649C75.2904 26.0649 73.2582 26.7954 64.0232 22.0482Z",
    fill: "#1EE2FA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9404 24.373C74.0201 26.5185 75.2904 26.0655 75.2904 26.0655L76.002 23.5815C73.6802 24.0743 71.3149 24.3394 68.9404 24.373Z",
    fill: "#14C5FA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5067 8.03973L74.2998 12.1088C76.075 11.9143 77.8339 11.5945 79.563 11.1518L80.6287 7.43164C79.9357 7.68033 79.2268 7.88347 78.5067 8.03973Z",
    fill: "#14C5FA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2747 16.002L65.593 20.5302C69.409 20.802 73.2439 20.633 77.0203 20.0267L78.43 15.106C75.7579 15.7277 73.0197 16.0285 70.2747 16.002Z",
    fill: "#14C5FA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0232 22.0486L79.4808 7.69103L75.2905 26.0654L81.2011 5.43359L64.0232 22.0486Z",
    fill: "#9CFFFC"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4751 0L83.644 3.10369L86.3263 4.72559L83.3925 5.84355L82.6609 8.86648L80.6789 6.45364L77.5444 6.69996L79.2532 4.09085L78.0476 1.22025L81.086 2.0204L83.4751 0Z",
    fill: "#FFD829"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6441 3.10348L83.4826 0.137207C83.3961 0.917122 83.3096 1.69702 83.223 2.47689C83.1865 2.80645 83.1487 3.14056 83.0253 3.44881C83.4091 3.84463 83.7395 4.28785 84.0083 4.76746L82.4985 5.19503C82.4354 5.80236 82.2655 6.39413 81.9964 6.94366C81.5485 6.41894 81.1838 5.82993 80.915 5.19683C80.3433 5.4251 79.7376 5.55898 79.1219 5.59314C79.4864 5.13844 79.8731 4.59182 79.7322 4.0287C79.6764 3.84603 79.5934 3.67264 79.4857 3.51428L78.0952 1.23245L78.0471 1.21976L79.2527 4.09043L77.5439 6.69955L80.679 6.45369L82.6613 8.86646L83.3929 5.84354L86.3267 4.72551L83.6441 3.10348Z",
    fill: "#FFB70F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2_13135",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.40778 20.4995) scale(9.78885 9.67239)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2_13135",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6704 20.4995) scale(9.78885 9.67239)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2_13135",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.3608 11.5015) scale(9.78885 9.67239)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2_13135",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.5706 11.5015) scale(9.78885 9.67239)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2_13135",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-76.5709 61.486) scale(12.8125 12.6464)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2_13135",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-155.892 61.486) rotate(180) scale(12.8125 12.6464)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2_13135",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.0445 34.677) scale(27.5576 27.2468)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2_13135",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-19.9664 38.3301) scale(17.4994 17.2978)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2_13135",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-230.57 38.0225) rotate(180) scale(17.4994 17.2977)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2_13135",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-85.8434 61.486) scale(12.8127 12.6464)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#F53990"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2_13135",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-209.82 61.486) rotate(180) scale(12.8125 12.6464)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#F53990"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2_13135",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.1344 35.9272) scale(9.73539 9.62266)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#F53990"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2_13135",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-380.857 35.9267) rotate(180) scale(9.73539 9.62266)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#F53990"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2_13135",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.5463 34.677) scale(27.5576 27.2468)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#F53990"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2_13135",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.322 23.8589) scale(11.7281 11.5885)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnAnimal);
export default __webpack_public_path__ + "static/media/btnAnimal.a18dfaabb1ebe515e5d84553fea8ce4b.svg";
export { ForwardRef as ReactComponent };